// extracted by mini-css-extract-plugin
export default {"cashbackForm":"CashbackForm_cashbackForm__Pl9mS","actions":"CashbackForm_actions__TSnQ-","saveBtn":"CashbackForm_saveBtn__wyzus","deleteBtn":"CashbackForm_deleteBtn__zZLJS"};